<c-modal
  #uploadModal
  id="uploadModal"
  [visible]="showModal()"
  backdrop="static">
  <c-modal-header>
    <h5 cModalTitle>
      {{ title() }}
    </h5>
    <button
      aria-label="close upload modal"
      [cModalToggle]="uploadModal.id"
      [disabled]="req.isLoading(signalData()?.reqState)"
      (click)="closeModal()"
      size="sm"
      cButtonClose></button>
  </c-modal-header>
  <c-modal-body>
    <ng-content></ng-content>
  </c-modal-body>
  <c-modal-footer>
    <button
      cButton
      class="primary cursor-pointer"
      size="sm"
      [disabled]="isInValid() || req.isLoading(signalData()?.reqState)"
      (click)="onConfirm()">
      {{ actionButtonLabel() | titlecase }}
      @if (req.isLoading(signalData()?.reqState)) {
        <c-spinner size="sm"></c-spinner>
      }
    </button>
  </c-modal-footer>
</c-modal>
